import Aura from '@primevue/themes/aura'
import { type Pinia, createPinia } from 'pinia'
import { ToastService } from 'primevue'
import PrimeVue from 'primevue/config'
import { type App as AppType, type Component, createApp } from 'vue'
import App from '@/App.vue'
import { customColors, customLocale } from '@/constants'
import { router } from '@/routes'
import '@/tailwind.css'

const app: AppType = createApp(App as Component)

const pinia: Pinia = createPinia()
app.use(pinia)

app.use(router)

app.use(PrimeVue, {
    locale: customLocale,
    theme: {
        preset: Aura,
        options: {
            cssLayer: {
                name: 'primevue',
                order: 'tailwind-base, primevue, tailwind-utilities',
            },
            darkModeSelector: 'light',
        },
        semantic: customColors,
    },
})

app.use(ToastService)

app.mount('#app')
